import {
    SET_RESULT_SEARCH_QUOTE, SET_FILTERED_AND_SORTED_QUOTES, IS_LOADING, SET_ALL_QUOTES,
    SET_SELECTED_TYPE, SET_SELECTED_STATE, SET_START_DATE, SET_END_DATE,
    SET_CURRENT_QUOTE, NB_MAX_QUOTES_TO_DISPLAY, SET_DISPLAY_AS_LIST
} from './quoteConstants'
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { throwErrorMessage } from '../../lib/error_helper';
import { adaptQuoteForMyOpen } from './quoteCast';
import { setNbTotalResults } from '../contextInfos/contextInfosActions';
import { ALL_SELECT_OPTION } from '../../constants';
import { getSiteIds } from '../customerSite/customerSiteActions';
//import { downloadFile } from '../../utils';
import {MODULE_EXTRANET_QUOTES} from '../authorizedApps/authorizedAppsConstants'
import { sortListOfTableBy } from '../../utils';

export function quotesIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'quotes',
        isLoading: value
    };
}

export function setSelectedTypeAction(selectedType) {
    return {
        type: SET_SELECTED_TYPE,
        selectedType,
    }
}

export function setSelectedStateAction(selectedState) {
    return {
        type: SET_SELECTED_STATE,
        selectedState,
    }
}

export function setStartDateAction(startDate) {
    return {
        type: SET_START_DATE,
        startDate,
    }
}

export function setEndDateAction(endDate) {
    return {
        type: SET_END_DATE,
        endDate,
    }
}

export function setDisplayAsListAction(displayAsList) {
    return {
        type: SET_DISPLAY_AS_LIST,
        displayAsList,
    }
}

export function setResultSearchQuoteAction(resultSearchQuote) {
    return {
        type: SET_RESULT_SEARCH_QUOTE,
        resultSearchQuote,
    }
}

export function setCurrentQuoteAction(currentQuote) {
    return {
        type: SET_CURRENT_QUOTE,
        currentQuote,
    }
}

export function setFilteredAndSortedQuotesAction(quotes) {
    return {
        type: SET_FILTERED_AND_SORTED_QUOTES,
        quotes,
    }
}

export function setAllQuotesAction(allQuotes) {
    return {
        type: SET_ALL_QUOTES,
        allQuotes,
    }
}

export function getQuote(code, userId) {
    return (dispatch) => {
        const minLengthOfQuoteCode = 4;

        if (code.length < minLengthOfQuoteCode)
            return;

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/quote/get_quote/' + userId + "/" + code, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((quote) => {
                if (quote.quoteNotFound)
                    quote = null;

                dispatch(setResultSearchQuoteAction(quote));
            }).catch((err) => {
                console.error("Erreur : quoteActions - getQuote", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de l'quotee !",
                }))
            });
    }
}

export function loadQuotes(user, customerSiteId, allSites, quotesFitlers, nbTotalResults) {
    return (dispatch) => {
        let tableState = {
            pageSize: NB_MAX_QUOTES_TO_DISPLAY,
            pageNumber: 0,
        }

        dispatch(setFilteredAndSortedQuotes(quotesFitlers, tableState, user, customerSiteId, allSites, nbTotalResults))
    }
}

export function setFilteredAndSortedQuotes(quotesFilters, tableState, user, customerSiteId, allSites, nbTotalResults) {
    return (dispatch) => {

        if (!customerSiteId)
            return;

        dispatch(quotesIsLoading(true));

        let customerSiteIds = getSiteIds(customerSiteId, allSites);
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/quote/get_quotes_of_customer/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                customerSiteIds,
                userId: user.id,
                pageSize: tableState.pageSize,
                pageNumber: tableState.pageNumber,
                selectedState: quotesFilters.selectedState === ALL_SELECT_OPTION ? null : quotesFilters.selectedState,
                selectedType: quotesFilters.selectedType === ALL_SELECT_OPTION ? null : quotesFilters.selectedType,
                startDate: quotesFilters.startDate ? quotesFilters.startDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                endDate: quotesFilters.endDate ? quotesFilters.endDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                displayAllQuotes: quotesFilters.displayAllQuotes,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                let allQuotes = [];

                customerSiteIds.forEach(s => {
                    allQuotes = allQuotes.concat(result.quotes[s])
                })

                let transformedQuotes = allQuotes.map(a => adaptQuoteForMyOpen(a));
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_QUOTES, result.nbTotalQuotes));
                transformedQuotes = sortListOfTableBy(tableState.orderBy, tableState.descOrder, transformedQuotes);
                dispatch(applyFiltersAndSortQuotes(quotesFilters, transformedQuotes));
            }).catch((err) => {
                console.error("Erreur : quoteActions - setFilteredAndSortedQuotes", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des devis !",
                }))
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_QUOTES, 0));
                dispatch(quotesIsLoading(false));
            });
    }
}

function applyFiltersAndSortQuotes(quotesFilters, quotes) {
    return (dispatch) => {
        let filteredQuotes = filter(quotes);
        let sortedAndFilteredQuotes = sort(filteredQuotes);
        dispatch(setFilteredAndSortedQuotesAction(sortedAndFilteredQuotes));
        dispatch(quotesIsLoading(false));
    }
}

export function sort(quotes) {
    return quotes;
}

export function filter(quotes) {
    let filteredQuotes = quotes.filter(() => {
        return true;
    });

    return filteredQuotes;
}

export function setSelectedType(value) {
    return (dispatch) => {
        dispatch(setSelectedTypeAction(value));
    }
}

export function setSelectedState(value) {
    return (dispatch) => {
        dispatch(setSelectedStateAction(value));
    }
}

export function setStartDate(value) {
    return (dispatch) => {
        dispatch(setStartDateAction(value));
    }
}

export function setEndDate(value) {
    return (dispatch) => {
        dispatch(setEndDateAction(value));
    }
}

export function setDisplayAsList(value) {
    return (dispatch) => {
        dispatch(setDisplayAsListAction(value));
    }
}

export function getStates() {
    return ['in_progress', 'open', 'closed', 'cancelled'];
}

export function getTypes() {
    return ['affair', 'contract'];
}

export function downloadQuote() {
//export function downloadQuote(quote, user) {
    return () => {
        return;
        /*En stand by pour le moment
                dispatch(quotesIsLoading(true));
                const headers = new Headers({ 'Content-Type': 'application/json' });
        
                fetchWithTimeout("/api/v1/quote/download_quote", {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        userId: user.id,
                        quoteId: quote.id
                    })
                })
                    .then((response) => {
                        if (!response.ok)
                            throw Error(response.statusText);
        
                        return response;
                    })
                    .then((response) => response.json())
                    .then(result => {
                        if (result.length <= 0 || !result[0].datas) {
                            console.error("Le devis est introuvable")
                            dispatch(quotesIsLoading(false));
                            return;
                        }
        
                        let file = result[0];
        
                        var dataURI = "data:application/pdf;base64," + file.datas;
                        downloadFile(dataURI, file.datas_fname ? file.datas_fname : "Devis");
                        dispatch(quotesIsLoading(false));
                    }).catch((err) => {
                        console.error("Erreur : quoteActions - downloadInvoice", err);
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors du téléchargement du devis !",
                        }))
                        dispatch(quotesIsLoading(false));
                    });*/
    }
}